<my-header></my-header>
<div class="revieworder" *ngIf="!openProcessPaymentModal">
    <app-banner></app-banner>
    <div class="review-order">
        <div class="title">Review Order</div>
        <div class="order-list" *ngFor="let item of selectedTransDetails?.salesDetailsList; let i = index; let last = last"
            [ngClass]="{
                'first-record-top': selectedTransDetails?.salesDetailsList?.length > 1 && i === 0, 
                'last-record-bottom': selectedTransDetails?.salesDetailsList?.length > 1 && last,
                'middle-record': selectedTransDetails?.salesDetailsList?.length > 1 && i !== 0 && !last,
                'single-item': selectedTransDetails?.salesDetailsList?.length === 1
            }">
            <div class="item item--1">
                <img onerror="this.src='../assets/empty.jpg';" alt="" class="drug-img" [src]="getImageUrl(item?.rxDetails ? (item?.rxDetails?.ndc) : '' )" >
            </div>
            <div class="item item--2">
                <span>Rx/Item#</span>
                <span>{{(item?.rxDetails ? item?.rxDetails?.rxno: item?.itemID) }}</span>
            </div>
            <div class="item item--3">
                <span>Amount Due</span>
                <span>{{(((item?.rxDetails?.patamt) !== "0.0") ? (item?.rxDetails ? ((item?.rxDetails?.billtype === "C" ? (item?.rxDetails?.patamt - item?.discountAmount) : (item?.rxDetails?.copay - item?.discountAmount)) | currency) : (item?.price ? (item?.price | currency) : "$0.00")): "$0.00")}}</span>
            </div>
             <div class="item item--6">
                <span>Discount Amt</span>
                <span>${{item?.discountAmount ? ((item?.discountAmount)?.toFixed(2)) :  "0.00"}}</span>
            </div>
            <div class="item item--4">
                <span>Qty</span>
                <span>{{(item?.rxDetails ? (item?.rxDetails?.quant | number: '1.0-0'): (item?.qty | number: '1.0-0')) }}</span>
            </div>
            <div class="item item--5">
                <span>Drug /Item Name</span>
                <span class="drugName_display">{{(item?.rxDetails ?( item?.rxDetails?.detdrgname | titlecase | maskText:isGuestUser): (item?.itemDescription | titlecase)) }}</span>
            </div>
        </div>
    </div>

    <div class="order-place">
        <div class="section">
            <div class="sec sec--1">
                <span class="amt-label">Amount Due:
                    <span class="amt">{{this.selectedTransDetails?.amount | currency}}</span> 
                </span>
            </div>
            <div class="sec sec--2">
                <button type="button" class="cancel" (click)="goToTranscationList()">Cancel</button>
                <button type="button" class="pay-now" (click)="checkCopayValue()">Next</button>
            </div>
        </div>
    </div>
    <app-signature-capture *ngIf="captureSign" (isSignatureApplyied)="signatureCheck($event)" [CopayValue]="nonZeroCopay"></app-signature-capture>
</div>
